import React, { useState } from "react"
import { Link, useLocation, useNavigate } from "react-router-dom"
import {
  useRecoilState,
  useRecoilValue,
} from "recoil"
import {
  sizeState,
  themeState,
  userObjState,
  pagesNprofileState,
  updatedPagesObjState,
  updatedProfileObjState,
  editModeState,
  editObjState,
} from "../recoil-atom"

import LinkGroup from "./LinkGroup"

const LinkPage = ({ pageId }) => {
  const [size, setSize] = useRecoilState(sizeState)
  const [theme, setTheme] = useRecoilState(themeState)
  const [userObj, setUserObj] = useRecoilState(userObjState)
  const { pagesObj, profileObj, shortName } = useRecoilValue(pagesNprofileState)
  const [updatedPagesObj, setUpdatedPagesObj] =
    useRecoilState(updatedPagesObjState)
  const [editMode, setEditMode] = useRecoilState(editModeState)
  const [editObj, setEditObj] = useRecoilState(editObjState)

  const location = useLocation()

  if (
    !editMode &&
    updatedPagesObj[pageId].group0.length +
      updatedPagesObj[pageId].group1.length +
      updatedPagesObj[pageId].group2.length +
      updatedPagesObj[pageId].group3.length ===
      0
  ) {
    return <></>
  }

  return (
    <>
      <div className="page">
        {updatedPagesObj &&
          updatedPagesObj[pageId].groupOrder.map((groupId, index) => (
            <>
              <LinkGroup pageId={pageId} groupId={groupId} key={index} />
            </>
          ))}
      </div>

      <style jsx>{`
        .page {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          width: ${size.pageWidth}px;
          margin: 10px auto 0 auto;
          border-radius: 20px;
          padding: 10px 0;
          background-color: ${userObj ? userObj.colors.b0 : themeState.b0};
          box-shadow: 1px 1px 3px 1px ${userObj ? userObj.colors.b2 : theme.b2};
        }
      `}</style>
    </>
  )
}

export default LinkPage
